import { ApiFail } from './ApiFail';

export class ResponseParseFail extends ApiFail {}
